<template>
  <div class="funcion-page">
    <div class="container">
      <div class="funcion-content">
        <!-- Festival Badge -->
        <!--div class="festival-badge">FESTIVAL ARENA Y BARRO</div-->

        <!-- Event Title -->
        <h1 class="funcion-title">{{ evento.titulo }} <span v-if="evento.origen" class="funcion-origin">({{ evento.origen }})</span></h1>

        <!-- Date & Time -->
        <div class="funcion-date">
          <svg class="calendar-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
          <span><strong>Fecha:</strong> {{ evento.fecha }}</span>
        </div>

        <!-- Venue / Location -->
        <div class="funcion-venue" v-if="evento.venue">
          <svg class="venue-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span>
            <strong>Lugar: </strong>
            <a :href="evento.venue.mapUrl" target="_blank" rel="noopener" class="venue-link">
              {{ evento.venue.name }} 📍
            </a>
          </span>
        </div>

        <!-- STANDARD LAYOUT (single show) -->
        <template v-if="!evento.subShows">
          <!-- Description -->
          <div class="funcion-description">
            <p v-for="(parrafo, index) in evento.descripcion" :key="index">{{ parrafo }}</p>
          </div>

          <!-- Age Rating -->
          <div class="funcion-age">
            <strong>Edad mínima:</strong> {{ evento.edad }}
          </div>

          <!-- Event Image -->
          <div class="funcion-image" v-if="evento.imagen">
            <img :src="evento.imagen" :alt="evento.titulo">
          </div>

          <!-- Tickets Section -->
          <div class="tickets-section">
            <h2 class="tickets-title">Entradas</h2>

            <!-- In-person tickets -->
            <div class="ticket-option">
              <div class="ticket-icon">🎭</div>
              <div class="ticket-info">
                <h3>En boletería</h3>
                <p>Presentarse <strong>30 minutos antes</strong> de la función</p>
                <div class="ticket-price">$400</div>
              </div>
            </div>

            <!-- Online tickets -->
            <div class="ticket-option ticket-online" v-if="evento.redtickets">
              <div class="ticket-icon">🎟️</div>
              <div class="ticket-info">
                <h3>Compra anticipada</h3>
                <p>Comprá tu entrada online a través de RedTickets</p>
                <a :href="evento.redtickets" target="_blank" rel="noopener" class="redtickets-link">
                  <img src="/images/RedTicket.jpg" alt="Comprar en RedTickets" class="redtickets-img">
                </a>
              </div>
            </div>
          </div>
        </template>

        <!-- SUB-SHOWS LAYOUT (multiple shows in one event) -->
        <template v-else>
          <!-- Age Rating (shared) -->
          <div class="funcion-age">
            <strong>Edad mínima:</strong> {{ evento.edad }}
          </div>

          <!-- Each sub-show -->
          <div v-for="(sub, index) in evento.subShows" :key="index" class="sub-show-block">
            <div class="sub-show-header">
              <span class="sub-show-time">{{ sub.time }}</span>
              <h2 class="sub-show-title">{{ sub.titulo }} <span class="funcion-origin">({{ sub.origen }})</span></h2>
            </div>

            <div class="funcion-description">
              <p v-for="(parrafo, pIndex) in sub.descripcion" :key="pIndex">{{ parrafo }}</p>
            </div>

            <div class="funcion-image" v-if="sub.imagen">
              <img :src="sub.imagen" :alt="sub.titulo">
            </div>

            <!-- Sub-show tickets -->
            <div class="tickets-section sub-show-tickets">
              <h3 class="tickets-title">Entradas — {{ sub.titulo }}</h3>

              <div class="ticket-option">
                <div class="ticket-icon">🎭</div>
                <div class="ticket-info">
                  <h3>En boletería</h3>
                  <p>Presentarse <strong>30 minutos antes</strong> de la función</p>
                  <div class="ticket-price">$400</div>
                </div>
              </div>

              <div class="ticket-option ticket-online" v-if="sub.redtickets">
                <div class="ticket-icon">🎟️</div>
                <div class="ticket-info">
                  <h3>Compra anticipada</h3>
                  <p>Comprá tu entrada online a través de RedTickets</p>
                  <a :href="sub.redtickets" target="_blank" rel="noopener" class="redtickets-link">
                    <img src="/images/RedTicket.jpg" alt="Comprar en RedTickets" class="redtickets-img">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FuncionPage',
  data() {
    return {
      eventos: {
        '1': {
          titulo: 'El Quijote Popular',
          origen: 'Chile',
          fecha: 'Sábado 14 de Febrero - 21 hs',
          venue: {
            name: 'Teatro Babilonia - El Pinar (Sala)',
            mapUrl: 'https://maps.app.goo.gl/kQL5XygdunFnacNf9'
          },
          descripcion: [
            'Una versión libre y popular del clásico de Cervantes, donde un solo actor encarna múltiples personajes para contar la historia del caballero andante desde una mirada latinoamericana.',
            'Con humor, poesía y cercanía, El Quijote Popular resignifica el viaje, los sueños y las derrotas, y nos invita a preguntarnos qué lugar ocupan hoy los ideales, la locura y la imaginación en un mundo que parece haberlos olvidado.',
            'Un espectáculo íntimo y potente, que dialoga con la tradición teatral popular y con la necesidad de seguir creyendo en lo imposible.'
          ],
          edad: 'apto para todo público',
          imagen: '/images/prox_func/Quijote.jpg',
          redtickets: 'https://redtickets.uy/evento/FESTIVAL-ARENA-Y-BARRO--El-Quijote-Popular-Chile/27168/'
        },
        '2': {
          titulo: '8 Espejos',
          origen: 'Canelones',
          fecha: 'Viernes 20 de Febrero - 21 hs',
          venue: {
            name: 'Teatro Babilonia - El Pinar (Sala)',
            mapUrl: 'https://maps.app.goo.gl/kQL5XygdunFnacNf9'
          },
          descripcion: [
            '¿Qué agregar a una obra que nace de una verdad personal, de algo profundamente propio?',
            '8 espejos reúne ocho historias potentes para compartir, sin juzgar, sin juzgarse.',
            'Historias que surgieron en el espacio del taller, donde exploramos el alma y aprendemos a transformar lo vivido en la belleza del teatro.',
            'Hasta hace poco eran alumnos. Hoy son artistas que brillan con su propia dramaturgia, con estilos diversos y miradas singulares.',
            'Esa es la búsqueda de los talleres de Grupo Babilonia —la de docentes y alumnos—: buscar, equivocarnos, sostener el proceso juntos, reírnos, entregarnos al juego y compartir con los demás.'
          ],
          edad: 'apto para todo público',
          imagen: '/images/prox_func/8_Espejos.jpeg',
          redtickets: 'https://redtickets.uy/evento/FESTIVAL-ARENA-Y-BARRO--8-espejos/27166/'
        },
        '3': {
          titulo: 'La Loca del Bequeló',
          origen: 'Durazno',
          fecha: 'Sábado 21 de Febrero - 21 hs',
          venue: {
            name: 'Playa - Rambla: Bajada 30',
            mapUrl: 'https://maps.app.goo.gl/b1CQ3BuSKiwiXD5N8'
          },
          descripcion: [
            'Durante un siglo, la Loca del Bequeló ha sido en el recuerdo de los uruguayos, un emblema del período más sangriento de nuestras luchas civiles. En medio de un campo profanado por la violencia, se levanta como terrible estampa del desquicio de una época marcada por el dolor y la muerte.',
            'No interesa tanto que haya sido un personaje histórico o sólo una leyenda. Importa, en cambio, como oportunidad para reflexionar sobre el valor de la vida humana y la necesidad del reencuentro entre todos los habitantes de un país.'
          ],
          edad: 'apto para todo público',
          imagen: '/images/prox_func/La_loca_del_Bequelo.jpg',
          redtickets: 'https://redtickets.uy/evento/FESTIVAL-ARENA-Y-BARRO--La-loca-del-Bequelo/27170/'
        },
        '4': {
          titulo: 'Ernesto Díaz & Fabián Severo',
          origen: null,
          fecha: 'Viernes 13 de Febrero - 21 hs',
          venue: {
            name: 'Playa - Rambla: Bajada 30',
            mapUrl: 'https://maps.app.goo.gl/b1CQ3BuSKiwiXD5N8'
          },
          descripcion: [
            'Descripción próximamente.'
          ],
          edad: 'apto para todo público',
          imagen: null,
          redtickets: null
        },
        '5': {
          titulo: 'Buceo Invisible',
          origen: 'Montevideo',
          fecha: 'Viernes 27 de Febrero - 21 hs',
          venue: {
            name: 'Playa - Rambla: Bajada 30',
            mapUrl: 'https://maps.app.goo.gl/b1CQ3BuSKiwiXD5N8'
          },
          descripcion: [
            'Buceo Invisible es un proyecto musical que explora paisajes sonoros, climas y atmósferas desde una mirada urbana y sensible.',
            'Sus canciones transitan entre lo íntimo y lo expansivo, combinando melodías, texturas y palabras para construir un viaje donde la música invita a escuchar, a dejarse llevar y a habitar el presente.',
            'Un concierto que propone una experiencia sensorial, donde el sonido se vuelve espacio y cada tema abre una nueva escena.'
          ],
          edad: 'apto para todo público',
          imagen: '/images/prox_func/Buceo_Invisible.jpeg',
          redtickets: 'https://redtickets.uy/evento/FESTIVAL-ARENA-Y-BARRO--Buceo-Invisible/27165/'
        },
        '6': {
          titulo: 'Noche de Circo',
          origen: null,
          fecha: 'Sábado 28 de Febrero - 19:00 a 22:00 hs',
          venue: {
            name: 'Teatro Babilonia - El Pinar (Sala)',
            mapUrl: 'https://maps.app.goo.gl/kQL5XygdunFnacNf9'
          },
          edad: 'apto para todo público',
          subShows: [
            {
              time: '19 h',
              titulo: '¿Dónde estoy? ¿Quién Soy? ¿Para dónde voy?',
              origen: 'Brasil',
              descripcion: [
                'En un encuentro inusual, el payaso Surubim seduce al público con su ingenuidad, transitando situaciones de tensión, emoción, técnica y humor. Con irreverencia y sensibilidad, invita a vivir una experiencia circense que mezcla lo clásico y lo contemporáneo, en un delicado equilibrio entre la picardía y la elegancia.'
              ],
              imagen: '/images/prox_func/Donde_estoy.jpeg',
              redtickets: 'https://redtickets.uy/evento/FESTIVAL-ARENA-Y-BARRO---Donde-estoy-Quien-soy-Para-donde-voy-Brasil/27167/'
            },
            {
              time: '21 h',
              titulo: 'La Silueta del Circo',
              origen: 'Uruguay',
              descripcion: [
                'Un espectáculo de humor para adultos que propone hacer reír e incomodar al público, combinando comedia con un gran despliegue de disciplinas circenses y manipulación de objetos.',
                'Angelina, antigua diva del circo devenida en gran matrona, es la encargada de recibir al público y sostener el espectáculo frente a una noche llena de imprevistos y problemas. Desde ese lugar, va revelando fragmentos de su historia y algunos secretos del Circo Monticelli, recorriendo las luces y sombras del mundo circense y de la familia.',
                'Una propuesta irreverente, sensible y potente, donde el humor se cruza con la memoria, el absurdo y la ternura.'
              ],
              imagen: '/images/prox_func/la_silueta_del_circo.jpeg',
              redtickets: 'https://redtickets.uy/evento/FESTIVAL-ARENA-Y-BARRO---La-silueta-del-Circo/27172/'
            }
          ]
        },
        '7': {
          titulo: 'Tercer Fuerxa',
          origen: 'Canelones',
          fecha: 'Viernes 06 de Marzo - 21 hs',
          venue: {
            name: 'Teatro Babilonia - El Pinar (Sala)',
            mapUrl: 'https://maps.app.goo.gl/kQL5XygdunFnacNf9'
          },
          descripcion: [
            'Esta pieza escénica es el resultado de dos años de intensa co-creación colectiva.',
            'A través de un lenguaje propio, el espectáculo aborda temas profundos como la falsa personalidad, la dualidad entre víctimas y victimarios, y los eternos ciclos de vida.',
            'En una época donde todo sucede a gran velocidad, Tercer Fuerxa propone detenernos y contemplar el recorrido vital: desde el nacimiento hasta la muerte… y vuelta a empezar.',
            'Un loop infinito donde la vida y la muerte son entendidas como parte de una misma esencia.',
            'Porque aunque cada uno tenga su historia, la obra nos recuerda que todos somos parte de algo más grande. Todos somos uno.',
            'Espectáculo de Danza'

          ],
          edad: 'apto para todo público',
          imagen: '/images/prox_func/tercer_fuerxa.jpeg',
          redtickets: 'https://redtickets.uy/evento/FESTIVAL-ARENA-Y-BARRO---Tercer-Fuerxa/27177/'
        },
        '8': {
          titulo: 'Por culpa de la E',
          origen: 'Sin Fogón Fray Bentos',
          fecha: 'Sábado 07 de Marzo - 21 hs',
          venue: {
            name: 'Teatro Babilonia - El Pinar (Sala)',
            mapUrl: 'https://maps.app.goo.gl/kQL5XygdunFnacNf9'
          },
          descripcion: [
            'Por culpa de la E, de Estela Golovchenko, es una comedia grotesca contemporánea ambientada en una ciudad del interior del país.',
            'Tres amigas sexagenarias: Eugenia, Emilia y Elsa se reencuentran para celebrar la boda de una de ellas, luego de haber estado distanciadas por varios años. El propósito del encuentro es también conocer a Ema, con quien se casará Eugenia, personaje que no aparece en la obra, pero al que se alude constantemente.',
            'El encuentro entre viejas amigas se transforma en una confrontación ideológica que pone sobre la mesa las concepciones de género y de identidad al descubrir que Ema ha marcado de diferentes maneras la vida de las tres.',
            'El propio título ironiza sobre el motivo de su antigua disputa, aludiendo a los cambios culturales que cuestionan el uso del lenguaje inclusivo. Sin embargo, la obra va más allá de ese episodio y transgrede el tema de la deconstrucción de las categorías sexo-género para poner a prueba las lealtades y lashipocresías de la amistad femenina.',
            'Las tres mujeres finalmente logran desarticular los prejuicios de una generación frente a los nuevos discursos de género y diversidad, poniendo en valor el pasado común que las identifica y las une.'
          ],
          edad: 'apto para todo público',
          imagen: '/images/prox_func/por_culpa_de_la_e.jpeg',
          redtickets: 'https://redtickets.uy/evento/FESTIVAL-ARENA-Y-BARRO---Por-culpa-de-la-E/27174/'
        },
        '9': {
          titulo: 'Naipe Marcado Trío Tango',
          origen: 'Montevideo',
          fecha: 'Domingo 08 de Marzo - 20 hs',
          venue: {
            name: 'Teatro Babilonia - El Pinar (Sala)',
            mapUrl: 'https://maps.app.goo.gl/kQL5XygdunFnacNf9'
          },
          descripcion: [
            'Un recorrido por los grandes clásicos del tango, interpretados por dos guitarras y voz femenina. Una propuesta íntima que recupera la fuerza de la palabra, la emoción de la melodía y la profundidad de un repertorio que atraviesa generaciones.',
            'Desde una sonoridad cercana y sensible, Naipe Marcado propone un encuentro con el tango tradicional, poniendo en primer plano la voz y las cuerdas, y creando un clima cálido donde la música invita a escuchar, recordar y emocionarse.',
            'Un concierto para dejarse llevar por el pulso del Río de la Plata, entre nostalgia, pasión y belleza.'
          ],
          edad: 'apto para todo público',
          imagen: '/images/prox_func/naipe_marcado.jpeg',
          redtickets: 'https://redtickets.uy/evento/FESTIVAL-ARENA-Y-BARRO---Naipe-Marcado-Tango/27173/'
        },
        '10': {
          titulo: 'Orquesta Subtropical',
          origen: 'Uruguay',
          fecha: 'Viernes 20 de Marzo - 21 hs',
          venue: {
            name: 'Teatro Babilonia - El Pinar (Sala)',
            mapUrl: 'https://maps.app.goo.gl/kQL5XygdunFnacNf9'
          },
          descripcion: [
            'Espectáculo musical.'
          ],
          edad: 'apto para todo público',
          imagen: '/images/prox_func/orquestra_subtropical.jpg',
          redtickets: 'https://redtickets.uy/evento/ORQUESTA-SUBTROPICAL/28089/'
        },
        '11': {
          titulo: '8 Espejos',
          origen: 'Canelones',
          fecha: 'Sábado 21 de Marzo - 21 hs',
          venue: {
            name: 'Teatro Babilonia - El Pinar (Sala)',
            mapUrl: 'https://maps.app.goo.gl/kQL5XygdunFnacNf9'
          },
          descripcion: [
            '¿Qué agregar a una obra que nace de una verdad personal, de algo profundamente propio?',
            '8 espejos reúne ocho historias potentes para compartir, sin juzgar, sin juzgarse.',
            'Historias que surgieron en el espacio del taller, donde exploramos el alma y aprendemos a transformar lo vivido en la belleza del teatro.',
            'Hasta hace poco eran alumnos. Hoy son artistas que brillan con su propia dramaturgia, con estilos diversos y miradas singulares.',
            'Esa es la búsqueda de los talleres de Grupo Babilonia —la de docentes y alumnos—: buscar, equivocarnos, sostener el proceso juntos, reírnos, entregarnos al juego y compartir con los demás.'
          ],
          edad: 'apto para todo público',
          imagen: '/images/prox_func/8_Espejos.jpeg',
          redtickets: ''
        },
        '12': {
          titulo: '8 Espejos',
          origen: 'Canelones',
          fecha: 'Viernes 27 de Marzo - 21 hs',
          venue: {
            name: 'Teatro Babilonia - El Pinar (Sala)',
            mapUrl: 'https://maps.app.goo.gl/kQL5XygdunFnacNf9'
          },
          descripcion: [
            '¿Qué agregar a una obra que nace de una verdad personal, de algo profundamente propio?',
            '8 espejos reúne ocho historias potentes para compartir, sin juzgar, sin juzgarse.',
            'Historias que surgieron en el espacio del taller, donde exploramos el alma y aprendemos a transformar lo vivido en la belleza del teatro.',
            'Hasta hace poco eran alumnos. Hoy son artistas que brillan con su propia dramaturgia, con estilos diversos y miradas singulares.',
            'Esa es la búsqueda de los talleres de Grupo Babilonia —la de docentes y alumnos—: buscar, equivocarnos, sostener el proceso juntos, reírnos, entregarnos al juego y compartir con los demás.'
          ],
          edad: 'apto para todo público',
          imagen: '/images/prox_func/8_Espejos.jpeg',
          redtickets: ''
        }
      }
    }
  },
  computed: {
    evento() {
      const id = this.$route.params.id;
      return this.eventos[id] || {
        titulo: 'Evento no encontrado',
        origen: '',
        fecha: '',
        descripcion: ['Este evento no existe.'],
        edad: '',
        imagen: '',
        redtickets: ''
      };
    }
  }
}
</script>

<style scoped>
.funcion-page {
  background: #000;
  padding: 60px 0 80px;
  min-height: 50vh;
}

.funcion-content {
  max-width: 800px;
  margin: 0 auto;
  color: white;
}

/* Festival Badge */
.festival-badge {
  display: inline-block;
  background: linear-gradient(135deg, #c9a227 0%, #d4af37 50%, #c9a227 100%);
  color: #000;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  border-radius: 4px;
  margin-bottom: 20px;
}

/* Event Title */
.funcion-title {
  font-size: 42px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 25px 0;
  line-height: 1.2;
}

.funcion-origin {
  font-weight: 400;
  color: #ccc;
  font-size: 32px;
}

/* Date */
.funcion-date {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  color: #fff;
  margin-bottom: 10px;
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.05);
  border-left: 4px solid #c9a227;
  border-radius: 0 8px 8px 0;
}

.calendar-icon {
  color: #c9a227;
  flex-shrink: 0;
}

/* Venue */
.funcion-venue {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  color: #fff;
  margin-bottom: 35px;
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.05);
  border-left: 4px solid #c9a227;
  border-radius: 0 8px 8px 0;
}

.venue-icon {
  color: #c9a227;
  flex-shrink: 0;
}

.venue-link {
  color: #c9a227;
  text-decoration: none;
  transition: color 0.3s ease;
}

.venue-link:hover {
  color: #e0c040;
  text-decoration: underline;
}

/* Description */
.funcion-description {
  margin-bottom: 30px;
}

.funcion-description p {
  font-size: 18px;
  line-height: 1.8;
  color: #ddd;
  margin: 0 0 20px 0;
  text-align: justify;
}

.funcion-description p:last-child {
  margin-bottom: 0;
}

/* Age Rating */
.funcion-age {
  font-size: 16px;
  color: #aaa;
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  margin-bottom: 40px;
}

/* Event Image */
.funcion-image {
  margin-top: 40px;
  text-align: center;
}

.funcion-image img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

/* Tickets Section */
.tickets-section {
  margin-top: 60px;
  padding-top: 40px;
  border-top: 1px solid #333;
}

/* Sub-show blocks */
.sub-show-block {
  margin-top: 50px;
  padding-top: 40px;
  border-top: 1px solid #333;
}

.sub-show-block:first-of-type {
  margin-top: 30px;
  border-top: none;
  padding-top: 0;
}

.sub-show-header {
  margin-bottom: 25px;
}

.sub-show-time {
  display: inline-block;
  background: #c9a227;
  color: #000;
  font-size: 14px;
  font-weight: bold;
  padding: 5px 14px;
  border-radius: 4px;
  margin-bottom: 12px;
  letter-spacing: 0.05em;
}

.sub-show-title {
  font-size: 32px;
  font-weight: bold;
  color: #fff;
  margin: 0;
  line-height: 1.2;
}

.sub-show-tickets {
  margin-top: 30px;
  padding-top: 25px;
}

.sub-show-tickets .tickets-title {
  font-size: 22px;
}

.tickets-title {
  font-size: 32px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 30px 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ticket-option {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 25px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  margin-bottom: 20px;
  border: 1px solid #222;
  transition: all 0.3s ease;
}

.ticket-option:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: #333;
}

.ticket-icon {
  font-size: 36px;
  flex-shrink: 0;
}

.ticket-info {
  flex: 1;
}

.ticket-info h3 {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 10px 0;
}

.ticket-info p {
  font-size: 16px;
  color: #aaa;
  margin: 0 0 15px 0;
  line-height: 1.5;
}

.ticket-price {
  display: inline-block;
  font-size: 28px;
  font-weight: bold;
  color: #c9a227;
}

/* RedTickets Link */
.redtickets-link {
  display: inline-block;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.redtickets-link:hover {
  transform: scale(1.05);
}

.redtickets-img {
  max-width: 250px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.redtickets-link:hover .redtickets-img {
  box-shadow: 0 8px 25px rgba(201, 162, 39, 0.3);
}

/* Mobile */
@media (max-width: 767px) {
  .funcion-page {
    padding: 40px 20px 60px;
  }

  .funcion-title {
    font-size: 28px;
  }

  .funcion-origin {
    font-size: 22px;
    display: block;
    margin-top: 5px;
  }

  .funcion-date {
    font-size: 16px;
    padding: 12px 15px;
  }

  .funcion-venue {
    font-size: 16px;
    padding: 12px 15px;
  }

  .funcion-description p {
    font-size: 16px;
    text-align: left;
  }

  .festival-badge {
    font-size: 12px;
    padding: 6px 15px;
  }

  /* Mobile Tickets */
  .tickets-section {
    margin-top: 40px;
    padding-top: 30px;
  }

  .tickets-title {
    font-size: 24px;
    margin-bottom: 20px;
  }

  .ticket-option {
    flex-direction: column;
    gap: 15px;
    padding: 20px;
  }

  .ticket-icon {
    font-size: 30px;
  }

  .ticket-info h3 {
    font-size: 18px;
  }

  .ticket-info p {
    font-size: 15px;
  }

  .ticket-price {
    font-size: 24px;
  }

  .redtickets-img {
    max-width: 200px;
  }

  .sub-show-title {
    font-size: 24px;
  }

  .sub-show-tickets .tickets-title {
    font-size: 18px;
  }
}
</style>